<template>
  <CContainer fluid>
    <h3>Campa&ntilde;as</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-6" sm="6">
            <CInput 
              label="Buscar:" 
              :value.sync="searchWord" 
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol col="sm-6" sm="6">
            <CButton 
              color="success" 
              class="mt-4" 
              @click="goTo('agregar')">
              <CIcon name="cil-plus" />
              <span class="p-2 align-middle">Agregar</span>
            </CButton>
          </CCol>
        </CRow>
        <CDataTable hover :items="campaigns" :fields="fields" :items-per-page="itemsPerPage">
          <template #nombre_Campania="{item}">
            <td>
              <h4>{{item.nombre_Campania}}</h4>
            </td>
          </template>
          <template #fecha_Inicial="{item}">
            <td>
              <div>
                <i class="bi bi-calendar-check text-success"></i>
                <span> {{ moment(item.fecha_Inicial).format('DD/MM/YYYY') }}</span>
              </div>
              <div>
                <i class="bi bi-calendar-x text-danger"></i>
                <span> {{moment(item.fecha_Final).format('DD/MM/YYYY')}}</span>
              </div>
            </td>
          </template>
          <template #estado="{item}">
            <td>
              <div class="d-flex justify-content-center">
                <CBadge :color="getColor(item.estado)" v-if="item.estado">{{ campaignStatus[item.estado] }}</CBadge>
              </div>
            </td>
          </template>
          <template #fecha_Actualizacion="{item}">
            <td>
              <div>
                <i class="bi bi-calendar-date"></i>
                <span> {{moment(item.fecha_Actualizacion).format('DD/MM/YYYY')}}</span>
              </div>
              <div>
                <i class="bi bi-clock-history"></i>
                <span> {{moment(item.fecha_Actualizacion).format('HH:mm:ss')}}</span>
              </div>
            </td>
          </template>
          <template #info="{ item }">
            <td>
              <a href="#" style="text-decoration: none;" class="mb-2 p-2" @click="toggleDocument($event, item)">
                <CIcon class="text-dark"
                  :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'"></CIcon>
              </a>
            </td>
          </template>
          <template #details="{item}">
            <CCollapse class="my-3" :show="item._toggled">
              <div class="d-flex mx-4 d-flex justify-content-end">
                <a href="#" 
                  class="mr-2" 
                  @click="goTo('editar', item.id_Campania)">
                  <CIcon name="cil-pencil" size="lg" class="text-warning"></CIcon>
                </a>
                <a href="#" 
                  class="mr-2" 
                  @click="(e) => tryDelete(e, item.id_Campania)">
                  <CIcon name="cil-trash" size="lg" class="text-danger"></CIcon>
                </a>
                <a href="#" 
                  class="mr-2"
                  @click="() => $router.push({ path: `${rootPath}/productoscampanias` })">
                  <CIcon name="cil-barcode" size="lg" class="text-dark"></CIcon>
                </a>
              </div>
              <CRow>
                <div class="ml-4"><strong>Descripción: </strong></div>
                <p class="mx-4">
                  {{ item.descripcion }}
                </p>
              </CRow>
            </CCollapse>
          </template>
        </CDataTable>
        <CPagination 
          size="sm" 
          class="d-flex justify-content-center" 
          :activePage.sync="page" 
          :pages="pageCount"
          @update:activePage="(value, a) => getData(value, searchWord)" />
        </CCardBody>

        <CElementCover v-show="loading" />
    </CCard>
  </CContainer>
</template>
<script>
  import moment from "moment";
  import CONSTANTS from "@/constants";
  import { errorMessage } from "@/general";
  import { 
    dataGridCampanias,
    borrarCampania
  } from "@/api";

  const fields = [
    { 
      key: 'nombre_Campania', 
      label: 'Campaña', 
      _style:'text-align:center;'
    },
    { 
      key: 'fecha_Inicial', 
      label: 'Fechas', 
      _style:'text-align:center;'
    },
    { 
      key: 'estado', 
      label: 'Estado', 
      _style:'text-align:center;'
    },
    { 
      key: 'fecha_Actualizacion', 
      label: 'Actualización', 
      _style:'text-align:center;'
    },
    { 
      key: 'info', 
      label: ''
    },
  ]

  export default {
    data() {
      return {
        fields,
        loading: false,
        rootPath: "",
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        campaigns: [],
        campaignStatus: {
          'A': 'Activa',
          'P': 'Pausada',
          'F': 'Finalizada'
        },
        idCompaingSelected: ""
      }
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true
        this.searchWord = search

        try {
          const { count, results } = await dataGridCampanias(
            this,
            page,
            search
          )
          
          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }
          this.campaigns = results
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: errorMessage(error),
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      tryDelete(e, idCampaign) {
        e.stopPropagation();
        e.preventDefault();

        this.idCompaingSelected = idCampaign;

        CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar";
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "red";

        this.$confirm("¿Confirma que desea borrar la campaña?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          this.deleteCampaign();
        }).catch(() => {
            this.$alert("¡Se cancelo la acción!", "", "warning", CONSTANTS.configSimpleAlert);
        });
      },
      async deleteCampaign() {
        this.loading = true;

        try {
          await borrarCampania(this, this.idCompaingSelected);
          await this.getData(this.page, this.searchWord);

          this.$store.commit('setAlert', {
            color: "success",
            message: "Campaña borrada correctamente",
            show: 5
          })
        } catch(error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: errorMessage(error),
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      toggleDocument(e, item) {
        e.preventDefault();
        e.stopPropagation();

        this.$set(item, '_toggled', !item._toggled)
        this.$nextTick(() => { })
      },
      getColor(status) {
        if(status === 'A') return 'success'
        if(status === 'P') return 'warning'
        if(status === 'F') return 'danger'
      },
      goTo(to, idCampaign) {
        let routeForm = `${this.rootPath}/${to}`;

        if (to === "editar") {
          routeForm = `${routeForm}/${idCampaign}`;
        }

        this.$router.push({ path: routeForm });
      }
    },
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;

      this.getData();
    }
  }
</script>
